import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserLifecycle from './pages/UserLifecycle';
import GroupManagement from './pages/GroupManagement';
import AppManagement from './pages/AppManagement';
import AccessReviews from './pages/AccessReviews';
import SodConflicts from './pages/SodConflicts';
import AuditLog from './pages/AuditLog';
import PlatformUsers from './pages/PlatformUsers';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/lifecycle" element={<ProtectedRoute><UserLifecycle /></ProtectedRoute>} />
          <Route path="/groups" element={<ProtectedRoute><GroupManagement /></ProtectedRoute>} />
          <Route path="/apps" element={<ProtectedRoute><AppManagement /></ProtectedRoute>} />
          <Route path="/reviews" element={<ProtectedRoute><AccessReviews /></ProtectedRoute>} />
          <Route path="/sod" element={<ProtectedRoute><SodConflicts /></ProtectedRoute>} />
          <Route path="/audit" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
          <Route path="/platform-users" element={<ProtectedRoute><PlatformUsers /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;